import axios from 'axios';
import { handleAppError } from '../../components/handlers';
const getGeoLocationByLatLng = async (lat, lng) => {
  try {
    let latLng = lat + "," + lng
    let url = "https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyD9zjUeIvgdywGQz-YfLX-TKNp28xGlgAQ&latlng=" + latLng + "&sensor=false"
    const geoLocation = await axios.get(url)
    if (geoLocation.hasOwnProperty("data") && geoLocation.data.hasOwnProperty("results")) {
      return geoLocation.data.results
    } else {
      throw "No Location Found"
    }
  } catch (err) {
    console.log("getGeoLocationByLatLng -> err", err)
    handleAppError(err)
  }
}


export { getGeoLocationByLatLng }